/**
 * Project Icons & Colors
 *
 * Preset library for project customization.
 * Icons are SVG path data, colors are hex values.
 * Hash-based defaults ensure consistent assignment without database storage.
 */
// 16 curated icons for project identification
export const PROJECT_ICONS = [
    {
        key: 'folder',
        label: 'Folder',
        path: 'M3 7.5C3 6.12 4.12 5 5.5 5H10l2 2h6.5C19.88 7 21 8.12 21 9.5v8A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-10Z',
    },
    {
        key: 'rocket',
        label: 'Rocket',
        path: 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2zM9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5',
    },
    {
        key: 'bug',
        label: 'Bug',
        path: 'M8 2l1.88 1.88M14.12 3.88 16 2M9 7.13v-1a3 3 0 1 1 6 0v1M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6zM12 20v-9M6.53 9C4.6 8.8 3 7.1 3 5M6 13H2M6 17H2M18 13h4M18 17h4M17.47 9c1.93-.2 3.53-1.9 3.53-4',
    },
    {
        key: 'star',
        label: 'Star',
        path: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
    },
    {
        key: 'target',
        label: 'Target',
        path: 'M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zM12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zM12 14c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z',
    },
    {
        key: 'wrench',
        label: 'Wrench',
        path: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z',
    },
    {
        key: 'code',
        label: 'Code',
        path: 'M16 18l6-6-6-6M8 6l-6 6 6 6',
    },
    {
        key: 'palette',
        label: 'Palette',
        path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c3.31 0 6-2.69 6-6 0-4.97-4.48-9-10-9zM6.5 13c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13zM9.5 9c-.83 0-1.5-.67-1.5-1.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9zM14.5 9c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zM17.5 13c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
    },
    {
        key: 'globe',
        label: 'Globe',
        path: 'M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zM2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
    },
    {
        key: 'lock',
        label: 'Lock',
        path: 'M19 11H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7 11V7c0-2.76 2.24-5 5-5s5 2.24 5 5v4',
    },
    {
        key: 'lightning',
        label: 'Lightning',
        path: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
    },
    {
        key: 'heart',
        label: 'Heart',
        path: 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z',
    },
    {
        key: 'flag',
        label: 'Flag',
        path: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7',
    },
    {
        key: 'book',
        label: 'Book',
        path: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 4h16c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H6.5a2.5 2.5 0 0 1 0-5H20',
    },
    {
        key: 'chat',
        label: 'Chat',
        path: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
    },
    {
        key: 'box',
        label: 'Box',
        path: 'M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16ZM12 22V12M12 12 3 7m9 5 9-5',
    },
];
// 8 color options for project theming
export const PROJECT_COLORS = [
    { key: 'blue', hex: '#3b82f6', label: 'Blue' },
    { key: 'green', hex: '#22c55e', label: 'Green' },
    { key: 'purple', hex: '#8b5cf6', label: 'Purple' },
    { key: 'orange', hex: '#f97316', label: 'Orange' },
    { key: 'red', hex: '#ef4444', label: 'Red' },
    { key: 'pink', hex: '#ec4899', label: 'Pink' },
    { key: 'cyan', hex: '#06b6d4', label: 'Cyan' },
    { key: 'slate', hex: '#64748b', label: 'Slate' },
];
/**
 * Simple string hash function for deterministic defaults.
 * Uses djb2 algorithm for good distribution.
 *
 * Tolerates a non-string argument on purpose. The signature says `string`, but
 * the value arrives from a JSON API payload, so a wrong-shaped response (a
 * partial projection, or a list where a single project was expected) reaches
 * here as `undefined` and `undefined.length` threw. The only consumer is
 * getProjectIconAndColor, which feeds ProjectIcon (rendered inside the
 * dashboard's Layout HEADER), so that throw unmounted every project-scoped
 * page into AppErrorBoundary. Degrade to the empty-string hash instead: a
 * project with a malformed name gets a default icon, not a dead page.
 * See __tests__/projectIcons.test.ts (incident 2026-08-01).
 */
function hashString(str) {
    const safe = typeof str === 'string' ? str : '';
    let hash = 5381;
    for (let i = 0; i < safe.length; i++) {
        hash = ((hash << 5) + hash) ^ safe.charCodeAt(i);
    }
    return Math.abs(hash);
}
/**
 * Get icon and color for a project.
 * Returns explicit selection if set, otherwise hash-based defaults from project name.
 */
export function getProjectIconAndColor(project) {
    const hash = hashString(project.name);
    const icon = project.icon
        ? PROJECT_ICONS.find((i) => i.key === project.icon) ??
            PROJECT_ICONS[hash % PROJECT_ICONS.length]
        : PROJECT_ICONS[hash % PROJECT_ICONS.length];
    const color = project.iconColor
        ? PROJECT_COLORS.find((c) => c.key === project.iconColor) ??
            PROJECT_COLORS[hash % PROJECT_COLORS.length]
        : PROJECT_COLORS[hash % PROJECT_COLORS.length];
    return { icon, color };
}
//# sourceMappingURL=projectIcons.js.map